module.exports = __webpack_public_path__ + "static/media/login-abk.edfad91c.jpg";